gsap.registerPlugin(ScrollTrigger);
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);
import { ScrollToPlugin } from "gsap/all";
const headerArrow = {
  init() {
    let headerbtn = document.querySelector(".downarrow");

    let latest = document.querySelector(".section-latestnews");

    if (latest !== null) {
      headerbtn.addEventListener("click", () => {
        gsap.to(window, {
          duration: 1,
          scrollTo: { y: ".section-latestnews", offsetY: 100 },
        });
      });
    } else {
      headerbtn.addEventListener("click", () => {
        gsap.to(window, { duration: 1, scrollTo: { y: ".section-creation" } });
      });
    }
  },
};

export default headerArrow;
